var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Services"},_vm._l((_vm.services),function(service){return _c('Service',{key:service.id,attrs:{"imgID":service.imgID,"title":service.title,"text":service.text,"textID":service.textID,"image":service.image}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }